module.exports = __webpack_public_path__ + "static/img/伙伴客户-湘雅三医院.30df633d.png";